/* Safety (group "Account"): voice and likeness consent records (SAFE-10). The page where a person records,
   reviews and revokes consent before a cloned voice or a likeness can be generated. API: /api/v1/consents. */
import { lazy } from 'react';
import { ShieldCheck } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'safety',
  title: 'Voice and likeness consent',
  short: 'Consent',
  icon: ShieldCheck,
  group: 'Account',
  route: '/consents',
  order: 90,
  screen: lazy(() => import('./Screen.tsx')),
  capabilities: ['SAFE-10'],
  commands: [
    { id: 'consents', title: 'Voice and likeness consent', to: '/consents', keywords: ['consent', 'voice', 'clone', 'likeness', 'avatar', 'revoke'] },
  ],
});
